import React from 'react';
import { motion } from 'framer-motion';
import { ChromeButton } from './ChromeButton';
export function FinalCTA() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-41" data-mp="3udp0mtecbqr2">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-42" data-mp="c6iuzupli37o">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="relative overflow-hidden rounded-3xl bg-[#1d9bf0] px-6 py-14 text-center sm:px-12" data-id="element-43" data-mp="c83ori435i4h">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.18),transparent_55%)]" data-id="element-44" data-mp="qvx6b8cqeupp" />
          <div className="relative" data-id="element-45" data-mp="14whn5yz36ggk">
            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-46" data-mp="14tdbkgjakifv">
              Screenshot X posts the clean way
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-lg text-white/90" data-id="element-47" data-mp="2c5g8ebwkrcyl">
              Free, local-only, and privacy-first. Add X2PIC to Chrome and
              capture your first post in seconds.
            </p>
            <div className="mt-8 flex justify-center" data-id="element-48" data-mp="2m21bussy4g0b">
              <ChromeButton variant="light" data-id="element-49" data-mp="2r1xh0vddqdhg" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}